import { useLayoutEffect, useRef } from 'react';

import {
  useExplorationActions,
  useExplorationState,
  useFilteredVolumes,
} from '../../context/ExplorationContext';
import { useContainerSize } from '../../hooks/useContainerSize';
import { useExplorationTooltipHandlers } from '../../hooks/useExplorationTooltipHandlers';
import { useDrillPush } from '../../hooks/useDrillPush';
import {
  applyExplorationCanvasEmptyState,
  clearExplorationCanvasContent,
  explorationCanvasEmptyVolumesMessage,
} from '../explorationCanvasChrome';
import { renderTreemapView } from './renderTreemapView';

export default function TreemapCanvas() {
  const state = useExplorationState();
  const actions = useExplorationActions();
  const filtered = useFilteredVolumes();
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useContainerSize(containerRef);
  const { showTooltip, hideTooltip } = useExplorationTooltipHandlers();

  const handleDrill = useDrillPush();

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    if (filtered.length > 0) return;

    hideTooltip();
    applyExplorationCanvasEmptyState(el, explorationCanvasEmptyVolumesMessage);
    return () => {
      clearExplorationCanvasContent(el);
    };
  }, [filtered.length, hideTooltip]);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el || !size.w || !filtered.length) return;

    return renderTreemapView(el, {
      view: state.view,
      secondary: state.secondary,
      groupByAccount: state.groupByAccount,
      tagKey: state.tagKey,
      volumes: filtered,
      onSelectVolume: actions.selectVolume,
      onDrill: handleDrill,
      showTooltip,
      hideTooltip,
    });
  }, [
    filtered,
    state.view,
    state.secondary,
    state.groupByAccount,
    state.tagKey,
    size,
    actions.selectVolume,
    handleDrill,
    showTooltip,
    hideTooltip,
  ]);

  return <div ref={containerRef} className="exploration-canvas treemap-canvas" />;
}
